import React, { useMemo } from "react";
import { River } from "../images/River";
import { Alert } from "../images/Alert";
import { Notification } from "../images/Notification";
import { RightArrow } from "../images/RightArrow";

const RiverList = ({ rivers, onRiverClick, selectedRegion }) => {
  const uniqueSortedRivers = useMemo(() => {
    if (!Array.isArray(rivers)) return [];

    // ✅ REMOVE DUPLICATES USING river_id
    const uniqueMap = new Map();

    rivers.forEach((river) => {
      if (!uniqueMap.has(river.river_id)) {
        uniqueMap.set(river.river_id, river);
      }
    });

    // Convert back to array & sort
    return Array.from(uniqueMap.values()).sort((a, b) => {
      const nameA = a.river_name?.toLowerCase() || "";
      const nameB = b.river_name?.toLowerCase() || "";
      return nameA.localeCompare(nameB);
    });
  }, [rivers]);

  return (
    <div
      className={`rivers-list ${
        selectedRegion === "all" ? "show-list" : ""
      }`}
    >
      {uniqueSortedRivers.length > 0 ? (
        <ul className="list-unstyled">
          {uniqueSortedRivers.map((river) => (
            <li key={river.river_id}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onRiverClick(river.river_id);
                }}
              >
                <div className="rivers-list-icon">
                  <div className="icon">
                    <River />
                    <div className="badge-label">
                      {Number(river.alert_count) > 0 ? (
                        <Alert />
                      ) : Number(river.notification_count) > 0 ? (
                        <Notification />
                      ) : null}
                    </div>
                  </div>

                  <div className="text">
                    <h4>{river.river_name}</h4>
                    <p>{river.facilities?.length || 0} Facilities</p>
                  </div>
                </div>

                <div className="rivers-list-text-arrow">
                  <p>{river.facilities?.length || 0} Facilities</p>
                  <div className="rivers-list-arrow">
                    <RightArrow />
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <h4>No rivers found in this region.</h4>
      )}
    </div>
  );
};

export default RiverList;
